import React from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import CommonTrainingList from './Common/CommonTrainingList';

const TrainingPage = () => {
    return (
        <PageWrapper title="Treinamentos">
            <Page container="fluid">
                <div className="row">
                    <div className="col-12">
                        <CommonTrainingList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};


export default TrainingPage;